import { useRef } from 'react';
import { useMutation } from '@tanstack/react-query';

import { AppApiV2, ImageUploadResultDto } from '../../../../../lib/api/app/AppApiV2';
import { extractErrorMessage, ErrorResponseType } from '../../../../../lib/utils/checkErrorResponse';
import toastMsg from '../../../../../lib/toastMsg';
import appToastMsg from '../../../../../constants/service/toastMsg/appToastMsg';
import { SlideImage } from '../types';

const extractPathFromUrl = (imageUrl: string): string => {
  try {
    return new URL(imageUrl).pathname.replace(/^\//, '');
  } catch {
    return imageUrl;
  }
};

export const useSlideImageUploadMutate = (onChange?: (next: SlideImage | null) => void) => {
  const onChangeRef = useRef(onChange);
  onChangeRef.current = onChange;

  return useMutation({
    mutationFn: (file: File) => AppApiV2.uploadsRectangleImage(file),
    onSuccess: (data: ImageUploadResultDto) => {
      const slideImage: SlideImage = {
        url: data.imageUrl,
        path: extractPathFromUrl(data.imageUrl),
        width: data.width,
        height: data.height,
      };
      toastMsg.success(appToastMsg.ADD_TEMP_IMG_REQUEST_SUCCESS);
      onChangeRef.current?.(slideImage);
    },
    onError: (err: ErrorResponseType) => {
      toastMsg.error(extractErrorMessage(err));
    },
  });
};
